<template>
<validation-provider :name="label" :rules="rule" v-slot="validationContext">
  <div class="preview-holder"  @mouseover="isShown = true" @mouseleave="isShown = false" :class="{'invalid': getValidationState(validationContext) === false}">
    
    <Transition>
      <div class="remove-logo d-flex justify-content-center align-items-center" v-if="isShown && isDeleteButtonShow && (logoPreview || imagePath)" @click="removeLogo">
        <i class="bx bx-trash-alt"></i>
      </div>
    </Transition>
    <div v-bind:style="background" class="logo-container"></div>
    <b-btn variant="primary" class="btn-upload">Upload Image</b-btn>
    <template v-if="shouldValidate">
      <b-form-file
      class="file-uploader"
      type="file"
      v-model="file"
      @click.native="fileClick"
      @blur.native="fileBlur"
      @change="onFileChange"
      plain
    />
    <b-form-invalid-feedback>
      {{ validationContext.errors[0] }}
    </b-form-invalid-feedback>
    </template>

    <template v-if="!shouldValidate">
      <b-form-file
        class="file-uploader"
        type="file"
        v-model="file"
        @click.native="fileClick"
        @blur.native="fileBlur"
        @change="onFileChange"
        plain
      />
    </template>
  </div>
</validation-provider>
</template>

<script>
import shortid from "shortid";
import _ from "lodash";

export default {
  name: 'image-uploader',
  data(){
    return {
      dialogActive: false,
      isShown: false,
      file: null,
      imagePath: null,
      logoPreview: null,
      logo: {
        filename: null,
        type: null,
        base64: null
      },
      isDeleteButtonShow: true,
    }
  },
  computed: {
    background: {
      get(){
        var backgroundImage = require('../assets/images/img-placeholder.png');
        if(this.imagePath){
          backgroundImage = this.imagePath;
        }
        
        if(this.logoPreview){
          backgroundImage = this.logoPreview
        } 

        return {
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center center',
          backgroundImage: 'url(' + backgroundImage + ')' 
        };
      }
    },
    rule: {
      get(){
        if(this.shouldValidate){
          return this.isRequired ? 'required':'';
        } else {
          return '';
        }
      }
    },
    shouldValidate: {
      get(){
        return this.isRequired && (this.imagePath == null || this.imagePath == '');
      }
    }
  },
  props: ['label','isRequired','imageSrc','value', 'showDeleteButton'],
  watch: {
    imageSrc(newVal){
      this.logoPreview = null;
      this.imagePath = newVal;
    },
  },
  methods: { 
    fileClick(e){
      e.target.focus(); // Fix for safari not triggering blur.
      if(!this.dialogActive){
        this.dialogActive = true;
      } else {
        e.preventDefault();
      }
    },
    fileBlur(){
      var _this = this;
      setTimeout(() => {
        _this.dialogActive = false;
      }, 2000);
    },
    onFileChange(e){
      const reader = new FileReader();
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length){
        this.logoPreview = null;
        this.$emit("input", {
          filename: null,
          type: null,
          base64: null
        });
        return;
      }

      this.logoPreview = URL.createObjectURL(files[0]);

      reader.onloadend = () => {
        var base64Data = reader.result;
        this.logo.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ''), 'base64');
        this.logo.type = base64Data.split(';')[0].split('/')[1];
        if(this.logo.type == 'svg+xml'){
          this.logo.type = 'svg';
        }
        this.logo.filename = `${shortid.generate()}.${this.logo.type}`;
        this.$emit("input", _.cloneDeep(this.logo));
      }
      reader.readAsDataURL(files[0]);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    removeLogo(){
      this.$emit("input", {
        filename: null,
        type: null,
        base64: null
      });
      this.file = null;
      this.imagePath = null;
      this.logoPreview = null;
    }
  },
  mounted(){
    this.imagePath = this.imageSrc;
    this.isDeleteButtonShow = this.showDeleteButton ?? true;
  }
}
</script>

<style>
.item-logo {
  max-width: 200px;
  max-height: 239px;
}

.preview-holder {
  width: 200px;
  height: 239px;
  background: #B0B3BC;
  border-radius: 8px;
  position: relative;
}

.preview-holder.invalid {
  border: solid 1px #FF0000;
}

.file-uploader {
  font-size: 20px;
  position: absolute;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}

.btn-upload {
  width: 100%;
  position: absolute;
  bottom: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.remove-logo {
  cursor: pointer;
  border-radius: 50%;
  background: #BCBCBC;
  width: 30px;
  height: 30px;
  position: absolute;
  right: -10px;
  top: -10px;
  color: #E73092;
  transition: opacity 3s;
}

.remove-logo.shown {
  opacity: 1;
}

.remove-logo:hover {
  background: #E73092;
  color: #FFF;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.logo-container {
  width: 100%; 
  height: 200px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>